import { HttpClient } from "./HttpClient"

export const CarruselService = {
    saveImage: async function(form){
        return await HttpClient.post(`/images/create-image-carrusel`, form).then(response => response)
    },

    getImages: async function(){
        return await HttpClient.get(`/images/get-carrusel`).then(response => response);
    },

    deleteImage: async function (id){
        return await HttpClient.delete(`/images/delete-image-carrusel/${id}`).then(response => response)
    },

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async editImg(form){
        return await HttpClient.post(`/images/modify-image-carrusel`, form).then(response => response)
    }
}